// @ts-check
(function(){
  // Guard contra doble inicialización (tipado seguro)
  /** @type {any} */
  (window).__MGO_VARIANTS_INIT__ = (window && /** @type {any} */(window).__MGO_VARIANTS_INIT__) || false;
  if (/** @type {any} */(window).__MGO_VARIANTS_INIT__) return;
  /** @type {any} */(window).__MGO_VARIANTS_INIT__ = true;

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.product-variants__options');
    const sizeContainer = document.querySelector('.product-variants--size .variant-products');
    const ADD_TO_CART_SELECTOR = '.product-showcase__add-to-cart, #ps-add-to-cart';
    /** @type {AbortController | null} */
    let currentController = null;
    /** @type {string | null} */
    let lastPathname = null;
    /** @type {string | null} */
    let lastSelectedSizeValue = null;
    /** @type {{type: string, sellingPlanId: string, variantId: string} | null} */
    let persistedPurchaseChoice = null;
    let hasUserPurchaseChoice = false;

    document.addEventListener('pdp:purchase-choice-changed', (event) => {
      const detail = /** @type {{type?: string, sellingPlanId?: string, variantId?: string, origin?: string}|undefined} */((/** @type {CustomEvent} */(event)).detail);
      if (!detail || !detail.type) return;
      persistedPurchaseChoice = {
        type: detail.type || '',
        sellingPlanId: detail.sellingPlanId || '',
        variantId: detail.variantId || '',
      };
      if (detail.origin === 'user') {
        hasUserPurchaseChoice = true;
      }
    });

    /**
     * @param {HTMLElement | null} optionEl
     * @param {boolean} markAsUser
     */
    function persistPurchaseChoice(optionEl, markAsUser) {
      if (!optionEl) return;
      persistedPurchaseChoice = {
        type: optionEl.getAttribute('data-type') || '',
        sellingPlanId: optionEl.getAttribute('data-selling-plan-id') || '',
        variantId: optionEl.getAttribute('data-variant-id') || '',
      };
      if (markAsUser) hasUserPurchaseChoice = true;
    }

    /**
     * @param {string} type
     * @returns {boolean}
     */
    function isSubscribeLikeType(type) {
      return !!type && type.indexOf('subscription') === 0;
    }

    /**
     * @param {Element | null} optionEl
     * @returns {boolean}
     */
    function isSpecialOption(optionEl) {
      if (!optionEl) return false;
      return (optionEl.getAttribute('data-type') || '') === 'subscription-special';
    }

    /**
     * @returns {{variantId: string, sellingPlanId: string, isStarterKitOverride: boolean}}
     */
    function getCurrentMainVariantSelection() {
      const urlVariantId = new URLSearchParams(window.location.search).get('variant') || '';
      if (urlVariantId) {
        const byUrlVariant = /** @type {HTMLElement|null} */(
          document.querySelector('.product-variants--size .variant-product__button[data-variant-id="' + CSS.escape(urlVariantId) + '"]')
        );
        if (byUrlVariant) {
          const variantId = byUrlVariant.getAttribute('data-cart-variant-id') || byUrlVariant.getAttribute('data-variant-id') || '';
          const sellingPlanId = byUrlVariant.getAttribute('data-cart-selling-plan-id') || '';
          const isStarterKitOverride = !!(
            byUrlVariant.getAttribute('data-cart-variant-id')
            && byUrlVariant.getAttribute('data-variant-id')
            && byUrlVariant.getAttribute('data-cart-variant-id') !== byUrlVariant.getAttribute('data-variant-id')
          );
          return { variantId, sellingPlanId, isStarterKitOverride };
        }
      }
      const selectedBtn = /** @type {HTMLElement|null} */(
        document.querySelector('.product-variants--size .variant-product.variant-product-selected .variant-product__button')
          || document.querySelector('.product-variants--size .variant-product.variant-product--active .variant-product__button')
          || document.querySelector('.product-variants--size .variant-product__button')
      );
      if (selectedBtn) {
        const variantId = selectedBtn.getAttribute('data-cart-variant-id') || selectedBtn.getAttribute('data-variant-id') || '';
        const sellingPlanId = selectedBtn.getAttribute('data-cart-selling-plan-id') || '';
        const isStarterKitOverride = !!(
          selectedBtn.getAttribute('data-cart-variant-id')
          && selectedBtn.getAttribute('data-variant-id')
          && selectedBtn.getAttribute('data-cart-variant-id') !== selectedBtn.getAttribute('data-variant-id')
        );
        return { variantId, sellingPlanId, isStarterKitOverride };
      }
      const params = new URLSearchParams(window.location.search);
      return { variantId: params.get('variant') || '', sellingPlanId: '', isStarterKitOverride: false };
    }

    function getCurrentMainVariantId() {
      return getCurrentMainVariantSelection().variantId;
    }

    /**
     * Keep product-showcase data attributes aligned with the latest fetched section.
     * This is required for fallback variant resolution when no size selector exists.
     * @param {Document} doc
     * @param {string} fallbackProductPath
     */
    function syncProductShowcaseDataAttrs(doc, fallbackProductPath) {
      const liveSectionRoot = /** @type {HTMLElement|null} */(document.querySelector('.product-showcase'));
      if (!liveSectionRoot) return;

      if (fallbackProductPath) {
        liveSectionRoot.setAttribute('data-product-url', fallbackProductPath);
      }

      const nextSectionRoot = /** @type {HTMLElement|null} */(doc.querySelector('.product-showcase'));
      if (!nextSectionRoot) return;

      const nextDefaultVariantId = nextSectionRoot.getAttribute('data-default-variant-id') || '';
      if (nextDefaultVariantId) {
        liveSectionRoot.setAttribute('data-default-variant-id', nextDefaultVariantId);
      }
    }

    /**
     * @param {ParentNode} scope
     * @param {{type: string, sellingPlanId: string, variantId: string} | null} choice
     * @returns {HTMLElement | null}
     */
    function findOptionByChoice(scope, choice) {
      if (!choice) return null;
      // Keep user intent first across size switches: restore by purchase type before strict IDs.
      if (choice.type && choice.sellingPlanId) {
        const byTypePlan = /** @type {HTMLElement|null} */(
          scope.querySelector('.product-showcase__subscribe--option[data-type="' + CSS.escape(choice.type) + '"][data-selling-plan-id="' + CSS.escape(choice.sellingPlanId) + '"]')
        );
        if (byTypePlan) return byTypePlan;
      }
      if (choice.type) {
        const byType = /** @type {HTMLElement|null} */(
          scope.querySelector('.product-showcase__subscribe--option[data-type="' + CSS.escape(choice.type) + '"]')
        );
        if (byType) return byType;
      }
      if (choice.variantId) {
        const byVariant = /** @type {HTMLElement|null} */(
          scope.querySelector('.product-showcase__subscribe--option[data-variant-id="' + CSS.escape(choice.variantId) + '"]')
        );
        if (byVariant) return byVariant;
      }
      return null;
    }

    /**
     * @param {ParentNode} scope
     * @param {{type: string, sellingPlanId: string, variantId: string} | null} choice
     * @returns {HTMLElement | null}
     */
    function findFallbackOptionByIntent(scope, choice) {
      if (!choice || !choice.type) return null;
      if (isSubscribeLikeType(choice.type)) {
        return /** @type {HTMLElement|null} */(scope.querySelector('.product-showcase__subscribe--option[data-type^="subscription"]'));
      }
      if (choice.type === 'onetime') {
        return /** @type {HTMLElement|null} */(scope.querySelector('.product-showcase__subscribe--option[data-type="onetime"]'));
      }
      return null;
    }

    /**
     * @param {ParentNode} scope
     * @param {{type: string, sellingPlanId: string, variantId: string} | null} choice
     * @returns {HTMLElement | null}
     */
    function resolvePreferredPurchaseOption(scope, choice) {
      let target = findOptionByChoice(scope, choice);
      if (!target) target = findFallbackOptionByIntent(scope, choice);
      if (!target) {
        target = /** @type {HTMLElement|null} */(
          scope.querySelector('.product-showcase__subscribe--option.is-selected')
            || scope.querySelector('.product-showcase__subscribe--option.is-active')
            || scope.querySelector('.product-showcase__subscribe--option[data-type^="subscription"]')
            || scope.querySelector('.product-showcase__subscribe--option[data-type="onetime"]')
            || scope.querySelector('.product-showcase__subscribe--option')
        );
      }
      return target;
    }

    /**
     * @param {ParentNode} scope
     * @param {HTMLElement | null} optionEl
     */
    function applyPurchaseSelectionClasses(scope, optionEl) {
      if (!optionEl) return;
      scope.querySelectorAll('.product-showcase__subscribe--option').forEach((el) => el.classList.remove('is-selected', 'is-active'));
      optionEl.classList.add('is-selected');
      if (!isSpecialOption(optionEl)) optionEl.classList.add('is-active');
    }

    /**
     * @param {ParentNode} scope
     * @param {HTMLElement | null} optionEl
     * @param {boolean} syncHref
     */
    function applyPurchaseSelectionState(scope, optionEl, syncHref = false) {
      if (!optionEl) return;
      applyPurchaseSelectionClasses(scope, optionEl);
      syncAccordionStateFromOption(optionEl, scope);
      if (syncHref) syncAddToCartHrefFromOption(optionEl);
    }

    /**
     * @param {HTMLElement} optionEl
     * @param {ParentNode} scope
     */
    function syncAccordionStateFromOption(optionEl, scope) {
      const selectedContainer = /** @type {HTMLElement|null} */(optionEl.closest('.product-showcase__subscribe--container'));
      if (!selectedContainer) return;

      const actionContainers = scope.querySelectorAll('.product-showcase__actions-container[data-collapsible="true"]');
      actionContainers.forEach((node) => {
        const el = /** @type {HTMLElement} */(node);
        el.classList.remove('dropdown-open');
      });

      const headers = scope.querySelectorAll('.product-showcase__subscribe--container .product-showcase__actions--header[aria-expanded]');
      headers.forEach((node) => {
        const el = /** @type {HTMLElement} */(node);
        el.setAttribute('aria-expanded', 'false');
      });

      const selectedActionContainer = /** @type {HTMLElement|null} */(selectedContainer.querySelector('.product-showcase__actions-container[data-collapsible="true"]'));
      const selectedHeader = /** @type {HTMLElement|null} */(selectedContainer.querySelector('.product-showcase__actions--header[aria-expanded]'));
      if (selectedActionContainer) selectedActionContainer.classList.add('dropdown-open');
      if (selectedHeader) selectedHeader.setAttribute('aria-expanded', 'true');
    }

    /**
     * @param {HTMLElement} optionEl
     */
    function syncAddToCartHrefFromOption(optionEl) {
      const atcButtons = /** @type {NodeListOf<HTMLAnchorElement>} */(document.querySelectorAll('.product-showcase__add-to-cart'));
      if (!atcButtons.length) return;

      const type = optionEl.getAttribute('data-type') || '';
      const planId = optionEl.getAttribute('data-selling-plan-id') || '';
      const variantOverride = optionEl.getAttribute('data-variant-id') || '';
      const mainSelection = getCurrentMainVariantSelection();
      const isSubscribe = isSubscribeLikeType(type);
      const canOptionOverrideVariant = type === 'subscription-special';
      const isV2Context = !!(document.querySelector('#subscribe-options-static')?.getAttribute('data-actions-version') === 'v2');

      // Para onetime: usar el variant real del PDP (data-variant-id o URL), nunca el SK (data-cart-variant-id)
      let mainVariantId;
      if (type === 'onetime') {
        mainVariantId = new URLSearchParams(window.location.search).get('variant') || '';
        if (!mainVariantId) {
          const selBtn = /** @type {HTMLElement|null} */(
            document.querySelector('.product-variants--size .variant-product.variant-product-selected .variant-product__button')
            || document.querySelector('.product-variants--size .variant-product__button')
          );
          mainVariantId = selBtn ? (selBtn.getAttribute('data-variant-id') || '') : '';
        }
        if (!mainVariantId) mainVariantId = mainSelection.variantId;
      } else {
        mainVariantId = mainSelection.variantId;
      }

      atcButtons.forEach((btn) => {
        const href = btn.getAttribute('href') || '/cart/add';
        const url = new URL(href, window.location.origin);
        url.searchParams.delete('selling_plan');

        if (canOptionOverrideVariant && variantOverride) url.searchParams.set('id', variantOverride);
        else if (!isV2Context && isSubscribe && variantOverride) url.searchParams.set('id', variantOverride);
        else if (mainVariantId) url.searchParams.set('id', mainVariantId);

        if (isSubscribe) {
          if (canOptionOverrideVariant && planId) {
            url.searchParams.set('selling_plan', planId);
          } else if (isV2Context && mainSelection.isStarterKitOverride) {
            if (mainSelection.sellingPlanId) url.searchParams.set('selling_plan', mainSelection.sellingPlanId);
          } else if (planId) {
            url.searchParams.set('selling_plan', planId);
          }
        }

        const nextHref = url.searchParams.toString() ? (url.pathname + '?' + url.searchParams.toString()) : url.pathname;
        btn.setAttribute('href', nextHref);
      });
    }

    // Attach listener in capture to preempt other handlers if needed
    if (container) {
      container.addEventListener('click', onVariantClick, true);
      // Marcar activo inicialmente según URL
      setVariantActiveFromUrl();
    }

    // Gestiona el bloque de bundle: si no existe en el destino, eliminar; si existe, reemplazar/insertar
    /** @param {Document} doc */
    function updateBundleBlock(doc) {
      const next = doc.querySelector('.product-variants--bundle');
      const curr = document.querySelector('.product-variants--bundle');
      if (!next) {
        if (curr && curr.parentElement) curr.parentElement.removeChild(curr);
        return;
      }
      if (curr) {
        curr.innerHTML = /** @type {HTMLElement} */(next).innerHTML;
        syncBundleSelectedLabel();
        return;
      }
      // Insertar en una posición estable (después de honey variants si existe)
      const info = document.querySelector('.product-showcase__info');
      if (info) {
        const clone = /** @type {HTMLElement} */ (next.cloneNode(true));
        const honeyBlock = info.querySelector('.product-variants.product-variants--honey');
        if (honeyBlock && honeyBlock.parentElement) honeyBlock.parentElement.insertBefore(clone, honeyBlock.nextSibling);
        else info.insertBefore(clone, info.firstChild);
        syncBundleSelectedLabel();
      }
    }

    /**
     * Replace the benefits block (block-table) so it reflects the target product's metafield
     * @param {Document} doc
     */
    function updateBenefits(doc) {
      const next = doc.querySelector('.product-showcase__info-block.block-table');
      const curr = document.querySelector('.product-showcase__info-block.block-table');
      if (!next) {
        // Target product has no benefits block; remove current if present
        if (curr && curr.parentElement) curr.parentElement.removeChild(curr);
        return;
      }
      if (!curr) {
        // Insert new block in a stable position (after title or at top of info)
        const info = document.querySelector('.product-showcase__info');
        if (info) {
          const clone = /** @type {HTMLElement} */(next.cloneNode(true));
          const titleBlock = info.querySelector('.product-showcase__info-block.block-title');
          if (titleBlock && titleBlock.parentElement) titleBlock.parentElement.insertBefore(clone, titleBlock.nextSibling);
          else info.insertBefore(clone, info.firstChild);
        }
        return;
      }
      // Both present: sync contents
      curr.innerHTML = /** @type {HTMLElement} */(next).innerHTML;
    }

    /**
     * Re-bind the nutrition drawer trigger + modal after their markup was
     * swapped/inserted via AJAX. The snippet's own JS only binds on initial load
     * and shopify:section:load — neither fires on a section-render swap — so the
     * fresh (unbound) trigger/modal would otherwise be inert.
     * @param {ParentNode} scope
     */
    function reinitNutritionalLabel(scope) {
      const init = /** @type {any} */(window).psNutritionLabelInit;
      if (typeof init !== 'function') return;
      try {
        init(scope);
      } catch (e) {
        console.warn('[MGO Variants] Nutrition label re-init failed:', e);
      }
    }

    /**
     * Replace the nutritional label drawer block so its trigger + modal contents
     * reflect the switched product. The drawer is product-level
     * (custom.nutritional_label_drawer metafield), so a blend/product switch must
     * rebuild it; otherwise the modal keeps showing the product loaded on page load.
     * @param {Document} doc
     */
    function updateNutritionalLabel(doc) {
      const SELECTOR = '.product-showcase__info-block.block-nutritional-label-drawer';
      const next = /** @type {HTMLElement|null} */(doc.querySelector(SELECTOR));
      const curr = /** @type {HTMLElement|null} */(document.querySelector(SELECTOR));

      // Target product has no nutritional drawer: drop the stale one if present.
      if (!next) {
        if (curr && curr.parentElement) curr.parentElement.removeChild(curr);
        return;
      }

      // Both present (the common blend-switch case): swap the trigger + modal
      // markup, then re-bind because the fresh nodes carry no binding flags.
      if (curr) {
        curr.innerHTML = /** @type {HTMLElement} */(next).innerHTML;
        reinitNutritionalLabel(curr);
        return;
      }

      // Current product lacked the block: insert it, preserving the drawer's
      // merchant-defined position by anchoring to the same preceding info-block
      // it has in the fetched document.
      const info = document.querySelector('.product-showcase__info');
      if (!info) return;
      const clone = /** @type {HTMLElement} */(next.cloneNode(true));

      let inserted = false;
      let prevBlock = next.previousElementSibling;
      while (prevBlock) {
        if (prevBlock.classList && prevBlock.classList.contains('product-showcase__info-block')) {
          const anchorClass = Array.from(prevBlock.classList).find(
            (c) => c.indexOf('block-') === 0 && c !== 'product-showcase__info-block'
          );
          if (anchorClass) {
            const liveAnchor = info.querySelector('.product-showcase__info-block.' + anchorClass);
            if (liveAnchor && liveAnchor.parentElement) {
              liveAnchor.parentElement.insertBefore(clone, liveAnchor.nextSibling);
              inserted = true;
              break;
            }
          }
        }
        prevBlock = prevBlock.previousElementSibling;
      }
      if (!inserted) info.appendChild(clone);
      reinitNutritionalLabel(clone);
    }

    /**
     * Replace the reviews badge block so it reflects the target product's ratings
     * @param {Document} doc
     */
    function updateReviewsBadge(doc) {
      const next = doc.querySelector('.product-showcase__info-block.block-reviews-badge');
      const curr = document.querySelector('.product-showcase__info-block.block-reviews-badge');
      if (!next || !curr) return;
      curr.innerHTML = /** @type {HTMLElement} */(next).innerHTML;
    }

    /**
     * Replace product description title block so it always reflects current product metafield
     * @param {Document} doc
     */
    function updateProductDescriptionTitle(doc) {
      const next = doc.querySelector('.product-showcase__info-block.block-product-description-title');
      const curr = document.querySelector('.product-showcase__info-block.block-product-description-title');

      if (!next) {
        if (curr && curr.parentElement) curr.parentElement.removeChild(curr);
        return;
      }

      if (!curr) {
        const info = document.querySelector('.product-showcase__info');
        if (info) {
          const clone = /** @type {HTMLElement} */(next.cloneNode(true));
          const reviewsBlock = info.querySelector('.product-showcase__info-block.block-reviews-badge');
          const titleBlock = info.querySelector('.product-showcase__info-block.block-title');
          if (reviewsBlock && reviewsBlock.parentElement) reviewsBlock.parentElement.insertBefore(clone, reviewsBlock);
          else if (titleBlock && titleBlock.parentElement) titleBlock.parentElement.insertBefore(clone, titleBlock);
          else info.insertBefore(clone, info.firstChild);
        }
        return;
      }

      curr.innerHTML = /** @type {HTMLElement} */(next).innerHTML;
    }

    /**
     * Replace the tabs accordion block so it reflects the target product's metafield
     * @param {Document} doc
     */
    function updateTabsAccordion(doc) {
      // DEBUG: Mostrar el título del producto y el HTML del bloque tabs_accordion
      try {
        const title = doc.querySelector('.product-showcase__title');
        const tabsBlock = doc.querySelector('.product-showcase__info-block.block-tabs-accordion');

      } catch(e) { console.warn('Debug tabs_accordion error', e); }

      const next = doc.querySelector('.product-showcase__info-block.block-tabs-accordion');
      const curr = document.querySelector('.product-showcase__info-block.block-tabs-accordion');
      if (!next) {
        if (curr && curr.parentElement) curr.parentElement.removeChild(curr);
        return;
      }
      if (!curr) {
        // Insert new block after info-tabs or at the top of info
        const info = document.querySelector('.product-showcase__info');
        if (info) {
          const clone = next.cloneNode(true);
          const after = info.querySelector('.product-showcase__info-block.block-info-tabs');
          if (after && after.parentElement) after.parentElement.insertBefore(clone, after.nextSibling);
          else info.insertBefore(clone, info.firstChild);
        }
        return;
      }
      curr.innerHTML = next.innerHTML;
      // Re-inicializa el JS de tabs/acordeón tras AJAX
      if (typeof window.initTabsAccordion === 'function') {
        window.initTabsAccordion();
      } else {
        // fallback: ejecuta el script inline si existe
        const script = document.querySelector('.tabs-accordion-section script');
        if (script) {
          try { eval(script.innerText); } catch(e) { console.warn('No se pudo re-ejecutar script de tabs-accordion', e); }
        }
      }
    }

    /**
     * Replace the info tabs block (product badges) so it reflects the target product's metafield
     * @param {Document} doc
     */
    function updateInfoTabs(doc) {
      const next = doc.querySelector('.product-showcase__info-block.block-info-tabs');
      const curr = document.querySelector('.product-showcase__info-block.block-info-tabs');
      const placeholder = document.querySelector('.info-tabs-placeholder');
      
      if (!next) {
        // Target product has no info tabs block
        if (curr && curr.parentElement) {
          // Create a placeholder to preserve position
          const ph = document.createElement('div');
          ph.className = 'info-tabs-placeholder';
          ph.style.display = 'none';
          curr.parentElement.insertBefore(ph, curr);
          curr.parentElement.removeChild(curr);
        }
        return;
      }
      
      if (!curr) {
        // Block doesn't exist, need to insert it
        const info = document.querySelector('.product-showcase__info');
        if (info) {
          const clone = /** @type {HTMLElement} */(next.cloneNode(true));
          
          // If placeholder exists, insert at its position
          if (placeholder && placeholder.parentElement) {
            placeholder.parentElement.insertBefore(clone, placeholder);
            placeholder.parentElement.removeChild(placeholder);
          } else {
            // Fallback: insert after reviews badge or title
            const reviewsBlock = info.querySelector('.product-showcase__info-block.block-reviews-badge');
            const titleBlock = info.querySelector('.product-showcase__info-block.block-title');
            if (reviewsBlock && reviewsBlock.parentElement) reviewsBlock.parentElement.insertBefore(clone, reviewsBlock.nextSibling);
            else if (titleBlock && titleBlock.parentElement) titleBlock.parentElement.insertBefore(clone, titleBlock.nextSibling);
            else info.insertBefore(clone, info.firstChild);
          }
        }
        return;
      }
      
      // Both present: sync contents and remove any placeholder
      curr.innerHTML = /** @type {HTMLElement} */(next).innerHTML;
      if (placeholder && placeholder.parentElement) {
        placeholder.parentElement.removeChild(placeholder);
      }
    }

    async function updateProductInfoTabs(productUrl) {
      const infoTabsSection = document.querySelector('.product-info');
      if (!infoTabsSection) return; // Section doesn't exist in template
      
      const sectionId = infoTabsSection.getAttribute('data-section-id');
      if (!sectionId) {
        console.warn('[MGO Variants] product-info-tabs section found but no data-section-id attribute');
        return;
      }
      
      const resolvedUrl = new URL(productUrl, window.location.origin);
      const sectionRenderUrl = resolvedUrl.pathname + '?section_id=' + encodeURIComponent(sectionId);
      
      try {
        const resp = await fetch(sectionRenderUrl);
        if (!resp.ok) {
          console.warn('[MGO Variants] Failed to fetch product-info-tabs:', resp.status);
          return;
        }
        const html = await resp.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const nextSection = doc.querySelector('.product-info');
        
        if (nextSection) {
          // Get the container to preserve structure
          const container = infoTabsSection.querySelector('.product-info__container');
          const nextContainer = nextSection.querySelector('.product-info__container');
          
          if (container && nextContainer) {
            container.innerHTML = nextContainer.innerHTML;
          } else {
            infoTabsSection.innerHTML = nextSection.innerHTML;
          }
          
          // Dispatch event to reinitialize tabs
          document.dispatchEvent(new CustomEvent('product-info-tabs:update'));
    
        } else {
          console.warn('[MGO Variants] No .product-info found in fetched HTML');
        }
      } catch (err) {
        console.error('[MGO Variants] Product Info Tabs update error:', err);
      }
    }

    /**
     * @param {string} productUrl - URL del nuevo producto
     */
    async function updateJunipReviews(productUrl) {
      // Buscar el widget de reviews actual
      const currentWidget = document.querySelector('.junip-product-review');
      if (!currentWidget) {

        return;
      }

      // Buscar la sección de reviews para obtener su section ID
      const reviewSection = document.querySelector('#junip-review-section-custom');
      if (!reviewSection) {
  
        return;
      }

      // Buscar el section ID en el elemento más cercano con data-section-id
      let sectionId = reviewSection.getAttribute('data-section-id');
      if (!sectionId) {
        const sectionElement = reviewSection.closest('[data-section-id]');
        if (sectionElement) {
          sectionId = sectionElement.getAttribute('data-section-id');
        }
      }

      if (!sectionId) {
        console.warn('[MGO Variants] No section ID found for Junip reviews');
        return;
      }

      // Hacer fetch de la sección de reviews del nuevo producto
      const resolvedUrl = new URL(productUrl, window.location.origin);
      const sectionRenderUrl = resolvedUrl.pathname + '?section_id=' + encodeURIComponent(sectionId);

      try {
        const resp = await fetch(sectionRenderUrl);
        if (!resp.ok) {
          console.warn('[MGO Variants] Failed to fetch Junip section:', resp.status);
          return;
        }

        const html = await resp.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Buscar el widget en el nuevo documento
        const newWidget = doc.querySelector('.junip-product-review');
        if (!newWidget) {
  
          return;
        }

        const newProductId = newWidget.getAttribute('data-product-id');
        if (!newProductId) {
          console.warn('[MGO Variants] No product ID in new Junip widget');
          return;
        }

      

        // MÉTODO 1: Eliminar widget existente e insertar uno nuevo
        // Esto fuerza a Junip a cargar el widget completamente nuevo
        const container = currentWidget.parentElement;
        if (container) {
          // Remover el widget actual
          currentWidget.remove();
          
          // Crear un nuevo widget con el nuevo product ID
          const newWidgetClone = newWidget.cloneNode(true);
          container.appendChild(newWidgetClone);
          
    
        }

        // MÉTODO 2 (alternativo): Actualizar data-product-id y reinicializar
        // Este método se ejecuta como respaldo si el método 1 no funciona
        setTimeout(() => {
          const widget = document.querySelector('.junip-product-review');
          if (widget) {
            widget.setAttribute('data-product-id', newProductId);
            
            // Llamar a window.junip.init() si está disponible
            // @ts-ignore - junip es una librería externa
            if (typeof window.junip !== 'undefined' && window.junip) {
              try {
                // @ts-ignore - junip es una librería externa
                if (typeof window.junip.init === 'function') {
                  // @ts-ignore - junip es una librería externa
                  window.junip.init();

                }
              } catch (error) {
                console.error('[MGO Variants] Error calling window.junip.init():', error);
              }
            }
          }
        }, 100);
      } catch (err) {
        console.error('[MGO Variants] Junip reviews update error:', err);
      }
    }

    /**
     * Re-render product-dependent sections that live OUTSIDE .product-showcase.
     * The blend/honey switcher only swaps the .product-showcase section via the
     * Section Rendering API, so sibling sections that read product.* metafields
     * (the "What's in …", How to use, FAQ, editorial video, etc.) would otherwise
     * keep showing the previously loaded product. We fetch the target product's
     * full page once and swap the innerHTML of each <div class="shopify-section">
     * whose content actually differs, skipping product-showcase and the JS-driven
     * widgets that are updated through their own dedicated paths.
     * @param {string} productUrl
     */
    async function updateAuxiliaryProductSections(productUrl) {
      const resolvedUrl = new URL(productUrl, window.location.origin);
      const targetPathname = resolvedUrl.pathname;

      // Preserve template view param if present (e.g. template-starter-kit).
      const viewParam = new URLSearchParams(window.location.search).get('view');
      if (viewParam) resolvedUrl.searchParams.set('view', viewParam);

      /** @type {Document} */
      let doc;
      try {
        const resp = await fetch(resolvedUrl.pathname + resolvedUrl.search);
        if (!resp.ok) {
          console.warn('[MGO Variants] Aux sections fetch failed:', resp.status);
          return;
        }
        const html = await resp.text();
        doc = new DOMParser().parseFromString(html, 'text/html');
      } catch (err) {
        if (err && /** @type {any} */(err).name === 'AbortError') return;
        console.error('[MGO Variants] Aux sections update error:', err);
        return;
      }

      // Bail if the visitor switched to another product while we were fetching.
      if (window.location.pathname !== targetPathname) return;

      // Product-dependent sections that live outside .product-showcase and must
      // reflect the switched product. Matched by their stable root class, then
      // resolved to the enclosing <div class="shopify-section"> wrapper. An
      // explicit allowlist (vs. swapping every section) keeps us from touching
      // page chrome or static sections whose live markup may have drifted from
      // the server render (lazy images, observers, etc.).
      const includeSelectors = [
        '.blend-ingredients', // "What's in <product>?"
        '.how-to-use', // How to use
        '.editorial-video', // Brand / ingredient video (self-upgrading web component)
        '.faq-section', // FAQ (re-initialized via pdp:aux-sections-updated)
        '.dual-image-content', // Hero dual-image
      ];

      let didSwap = false;
      const seen = new Set();
      includeSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          const liveWrapper = /** @type {HTMLElement|null} */(el.closest('.shopify-section'));
          if (!liveWrapper || !liveWrapper.id || seen.has(liveWrapper.id)) return;
          seen.add(liveWrapper.id);

          const nextWrapper = doc.getElementById(liveWrapper.id);
          if (!nextWrapper) return;

          // Skip when content is identical (same template + same metafields) so
          // self-upgrading web components and bound listeners stay untouched.
          if (liveWrapper.innerHTML === nextWrapper.innerHTML) return;
          liveWrapper.innerHTML = nextWrapper.innerHTML;
          didSwap = true;
        });
      });

      if (didSwap) {
        // Web components inside the swapped markup re-upgrade themselves on
        // insertion; sections that bind listeners once on load (e.g. FAQ) listen
        // for this event to re-initialize.
        document.dispatchEvent(new CustomEvent('pdp:aux-sections-updated', { detail: { url: resolvedUrl.href } }));
      }
    }

    if (sizeContainer) {
      sizeContainer.addEventListener('click', onSizeClick, true);
      setSizeActiveFromVariant();
      updateSelectedLabel(document);
    }

    // Inicializar selección de opción de compra (subscription / onetime) y ATC AJAX
    initPurchaseOptions();
    bindAddToCart();

    // Asegurar que el bloque de tamaños se muestre si corresponde al cargar la PDP
    ensureSizeBlockOnLoad();

    // Seleccionar por defecto la card del bundle que corresponde al producto actual
    setBundleActiveFromUrl();
    updateSelectedLabel(document);

    // On non-product pages, if URL has ?variant=, fetch correct prices on initial load
    syncPricesFromUrlVariantOnLoad();

    /**
     * On non-product pages, Liquid doesn't receive the ?variant= parameter.
     * This function detects if we're on a non-product page with a variant in the URL
     * and triggers a fetch to get the correct prices.
     */
    function syncPricesFromUrlVariantOnLoad() {
      const basePath = window.location.pathname;
      const isProductPage = basePath.startsWith('/products/');
      if (isProductPage) return; // Product pages handle this natively

      const params = new URLSearchParams(window.location.search);
      const variantId = params.get('variant');
      if (!variantId) return; // No variant in URL, nothing to sync

      // We have a variant in URL on a non-product page - fetch correct prices
      handleSelectVariant(variantId);
    }

    function syncActionsPriceFromActiveOption() {
      const optionsRoot = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
      const selected = /** @type {HTMLElement|null} */(
        resolvePreferredPurchaseOption(
          /** @type {ParentNode} */(optionsRoot || document),
          persistedPurchaseChoice
        )
          || optionsRoot?.querySelector('.product-showcase__subscribe--option.is-selected')
          || document.querySelector('.product-showcase__subscribe--option.is-active')
      );
      if (!selected) return;

      const type = selected.getAttribute('data-type') || '';
      const selectedPriceText = selected.getAttribute('data-price-text')
        || (selected.querySelector('.product-showcase__subscribe--options--price')?.textContent || '').trim();

      // 1) Sync option-specific price slots
      if (type.startsWith('subscription')) {
        const subSlot = document.querySelector('#pso-subscribe-price');
        if (subSlot && selectedPriceText) subSlot.textContent = selectedPriceText;
      } else if (type === 'onetime') {
        const oneSlot = document.querySelector('#pso-onetime-price');
        if (oneSlot && selectedPriceText) oneSlot.textContent = selectedPriceText;
      }

      // 2) Sync visible header price + compare in one pass to avoid flash
      const headerPriceWrap = /** @type {HTMLElement|null} */(document.querySelector('#ps-slot-price, .product-showcase__price'));
      if (!headerPriceWrap) return;

      const curr = /** @type {HTMLElement|null} */(headerPriceWrap.querySelector('.product-showcase__current-price'));
      const compare = /** @type {HTMLElement|null} */(headerPriceWrap.querySelector('.product-showcase__compare-price'));
      if (curr && selectedPriceText) curr.textContent = selectedPriceText;
      if (!compare) return;

      const prevCompareText = (compare.textContent || '').trim();
      const prevCompareVisible = compare.style.display !== 'none';

      if (!compare.dataset.originalCompare) {
        const existingCompare = (compare.textContent || '').trim();
        if (existingCompare) compare.dataset.originalCompare = existingCompare;
      }

      /** @type {string} */
      let compareText = '';
      if (type.startsWith('subscription')) {
        // For OTP accordion, keep Liquid compare when available.
        compareText = (compare.dataset.originalCompare || '').trim();
        if (!compareText) {
          const sourceCompare = /** @type {HTMLElement|null} */(
            selected.closest('.product-showcase__subscribe--container')?.querySelector('.product-showcase__compare-price')
          );
          compareText = (sourceCompare?.textContent || '').trim();
        }
        if (!compareText && optionsRoot) {
          const onetime = /** @type {HTMLElement|null} */(optionsRoot.querySelector('.product-showcase__subscribe--option[data-type="onetime"]'));
          compareText = (onetime?.getAttribute('data-price-text')
            || (onetime?.querySelector('.product-showcase__subscribe--options--price')?.textContent || '')).trim();
        }
        // Do not blank compare during subscription transitions; keep last visible value until fresh one arrives.
        if (!compareText) {
          compareText = prevCompareText || (compare.dataset.lastCompare || '').trim();
        }
      } else {
        compareText = (compare.dataset.originalCompare || '').trim();
      }

      compare.textContent = compareText;
      const currentText = (curr?.textContent || '').trim();
      const hasCompare = type.startsWith('subscription')
        ? ((!!compareText && compareText !== currentText) || prevCompareVisible)
        : (!!compareText && compareText !== currentText);
      compare.classList.toggle('is-hidden', !hasCompare);
      compare.setAttribute('aria-hidden', hasCompare ? 'false' : 'true');
      headerPriceWrap.classList.toggle('has-compare', hasCompare);
      if (hasCompare && compareText) compare.dataset.lastCompare = compareText;

      // 3) Sync header title + save badge dynamically from active option
      const headerTitleWrap = /** @type {HTMLElement|null} */(document.querySelector('.product-showcase__actions--header--title'));
      if (!headerTitleWrap) return;

      const sourceTitle = /** @type {HTMLElement|null} */(selected.querySelector('.product-showcase__subscribe--options--title'));
      const sourceBadge = /** @type {HTMLElement|null} */(selected.querySelector('.product-showcase__subscribe--options--title--save'));

      let titleText = '';
      if (sourceTitle) {
        titleText = Array.from(sourceTitle.childNodes)
          .filter((node) => node.nodeType === Node.TEXT_NODE)
          .map((node) => (node.textContent || '').trim())
          .filter((text) => text !== '')
          .join(' ')
          .trim();
      }

      if (!titleText) {
        titleText = Array.from(headerTitleWrap.childNodes)
          .filter((node) => node.nodeType === Node.TEXT_NODE)
          .map((node) => (node.textContent || '').trim())
          .filter((text) => text !== '')
          .join(' ')
          .trim();
      }

      const badgeText = (sourceBadge?.textContent || '').trim();
      const safeTitle = titleText ? `${titleText} ` : '';
      headerTitleWrap.innerHTML = `${safeTitle}<span class="product-showcase__actions--header--title--save"></span>`;

      const headerBadge = /** @type {HTMLElement|null} */(headerTitleWrap.querySelector('.product-showcase__actions--header--title--save'));
      if (!headerBadge) return;
      headerBadge.textContent = badgeText;
      headerBadge.style.display = badgeText ? '' : 'none';
    }

    /**
     * @param {boolean} isUpdating
     */
    function setPriceUpdatingState(isUpdating) {
      document.querySelectorAll('.product-showcase__price').forEach((el) => {
        el.classList.toggle('price-updating', !!isUpdating);
      });
    }

    /**
     * @param {MouseEvent} e
     */
    function onVariantClick(e) {
      const target = /** @type {HTMLElement} */ (/** @type {Element} */(e.target)).closest('.product-variants__option-button');
      if (!target || !container || !container.contains(target)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const url = target.getAttribute('data-url') || '';
      if (!url) return;
      // Record current selected size value to preserve across product change
      const selectedSizeBtn = document.querySelector('.product-variants--size .variant-product.variant-product-selected .variant-product__button');
      if (selectedSizeBtn) {
        lastSelectedSizeValue = selectedSizeBtn.getAttribute('data-option-value');
      }
      // Visual active state
      container.querySelectorAll('.product-variants__option').forEach(li => li.classList.remove('product-variants__option--active'));
      const li = target.closest('.product-variants__option');
      if (li) li.classList.add('product-variants__option--active');
      handleSelect(url);
    }

    /**
     * Click en opción de tamaño: recargar misma página con ?variant=ID y actualizar sólo precios/ATC/size block
     * @param {MouseEvent} e
     */
    function onSizeClick(e) {
      const target = /** @type {HTMLElement} */ (/** @type {Element} */(e.target)).closest('.variant-product__button');
      // No dependas de la referencia inicial (puede re-renderizarse). Vuelve a consultar el contenedor actual.
      const currentSizeContainer = document.querySelector('.product-variants--size .variant-products');
      if (!target || !currentSizeContainer || !currentSizeContainer.contains(target)) return;

      // If the clicked size is already selected, do nothing (avoid refreshing ATC/subscribe/one-time)
      const clickedLi = /** @type {HTMLElement|null} */(target.closest('.variant-product'));
      if (clickedLi && clickedLi.classList.contains('variant-product-selected')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const variantId = target.getAttribute('data-variant-id');
      if (!variantId) return;

      const params = new URLSearchParams(location.search);
      const currentVariantParam = params.get('variant');
      if (currentVariantParam && String(currentVariantParam) === String(variantId)) return;

      const val = target.getAttribute('data-option-value') || null;
      if (val) lastSelectedSizeValue = val;
      handleSelectVariant(variantId);
    }

    /**
     * Fetch and swap current section using Shopify section rendering API
     * @param {string} productUrl
     */
    async function handleSelect(productUrl) {
      const resolvedUrl = new URL(productUrl, window.location.origin);
      if (lastPathname === resolvedUrl.pathname) return;

      // Preserve template view parameter if present
      const currentViewParam = new URLSearchParams(window.location.search).get('view');
      if (currentViewParam) {
        resolvedUrl.searchParams.set('view', currentViewParam);
      }

      // Update URL (SEO-friendly)
      if (window.location.pathname !== resolvedUrl.pathname) {
        window.history.replaceState({ productUrl: resolvedUrl.href }, '', resolvedUrl.href);
      }

      // Abort previous request
      if (currentController) currentController.abort();
      currentController = new AbortController();

      const sectionRoot = document.querySelector('.product-showcase');
      const sectionId = String(sectionRoot ? (sectionRoot.getAttribute('data-section-id') || '') : '');
      // Preserve template view parameter if present (e.g., template-starter-kit)
      const currentParams = new URLSearchParams(window.location.search);
      const viewParam = currentParams.get('view');
      let sectionRenderUrl = resolvedUrl.pathname + '?section_id=' + encodeURIComponent(sectionId);
      if (viewParam) {
        sectionRenderUrl += '&view=' + encodeURIComponent(viewParam);
      }

      try {
        setPriceUpdatingState(true);
        const resp = await fetch(sectionRenderUrl, { signal: currentController.signal });
        const html = await resp.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Keep product URL and default variant fallback in sync after dynamic product switch.
        syncProductShowcaseDataAttrs(doc, resolvedUrl.pathname);

        // Si el nuevo producto tiene selector de talla y aún no hay ?variant en la URL,
        // applySizeAfterHoneySwitch() disparará enseguida un handleSelectVariant que
        // re-renderiza galería, acciones, precio y panel de compra con el estado final.
        // En ese caso omitimos aquí ese render intermedio para que todo se construya
        // una sola vez (evita el parpadeo de la galería y el "pestañazo" del panel).
        const willSwitchSize = !new URLSearchParams(location.search).get('variant')
          && !!doc.querySelector('.product-variants--size .variant-product__button[data-variant-id]');
        if (!willSwitchSize) updateGallery(doc);
        updateTitle(doc);
        updatePrice(doc);
        if (!willSwitchSize) updateAddToCart(doc);
        updateSelectedLabel(doc);
        updateDescription(doc);
        updateVariantsOptions(doc);
        updateSizeBlock(doc);
        updateBundleBlock(doc);
        updateBenefits(doc);
        updateNutritionalLabel(doc);
        updateTabsAccordion(doc);
        updateInfoTabs(doc);
        updateReviewsBadge(doc);
        updateProductDescriptionTitle(doc);
        updateProductInfoTabs(resolvedUrl.href);
        updateJunipReviews(resolvedUrl.href);
        // Re-render the product-dependent sections that live OUTSIDE
        // .product-showcase (What's in / How to use / FAQ / editorial video …),
        // which the main section swap above does not touch.
        updateAuxiliaryProductSections(resolvedUrl.href);
        // El bloque de acciones/panel de compra se renderiza una sola vez:
        // si va a seguir un cambio de talla, handleSelectVariant() hará
        // updateAddToCart + initPurchaseOptions + dispatch. Hacerlo también aquí
        // abre el panel y luego handleSelectVariant lo reemplaza y reabre -> "pestañazo".
        if (!willSwitchSize) {
          initPurchaseOptions();
          bindAddToCart();
          // Re-sync ATC href after updateAddToCart may have set the wrong plan (e.g. OTP accordion + SK)
          try {
            const activeOpt = /** @type {HTMLElement|null} */(
              document.querySelector('.product-showcase__subscribe--option.is-active')
                || document.querySelector('.product-showcase__subscribe--option.is-selected')
            );
            if (activeOpt) syncAddToCartHrefFromOption(activeOpt);
          } catch {}
        }

        // Re-mark active from current URL
        setVariantActiveFromUrl();
        setSizeActiveFromVariant();
        updateSelectedLabel(doc);
        setBundleActiveFromUrl();

        // Notify other modules (sticky ATC, etc.) - This will trigger ensureSingleOpen in product-showcase.js
        // Solo si NO va a seguir un cambio de talla; de lo contrario, handleSelectVariant
        // emite este evento una sola vez (evita abrir/cerrar/abrir el panel = "pestañazo").
        if (!willSwitchSize) {
          document.dispatchEvent(new CustomEvent('pdp:product-changed', { detail: { url: resolvedUrl.href, skipApplySelection: true } }));
        }

        // Broadcast updated sticky badge text (metafield-driven) from the newly fetched section
        try {
          const nextStickyBadge = /** @type {HTMLElement|null} */(doc.querySelector('.sticky-add-to-cart__product-percentage'));
          const badgeText = (nextStickyBadge?.textContent || '').trim();
          if (badgeText) {
            document.dispatchEvent(new CustomEvent('sticky:badge-text', { detail: { text: badgeText } }));
          }
        } catch {}

        // Sync price after product change event (cuando no sigue un cambio de talla;
        // si sigue, handleSelectVariant deja el precio/panel final).
        if (!willSwitchSize) {
          try { syncActionsPriceFromActiveOption(); } catch {}
        }

        lastPathname = resolvedUrl.pathname;

        // Aplicar la talla en el nuevo producto UNA sola vez para evitar fetches
        // duplicados que se abortan entre sí y reconstruyen la galería varias veces.
        // Prioridad: 1) preservar la talla previamente seleccionada si existe en el
        // nuevo producto; 2) fallback a Full (2da) o 1ra. Sincroniza precio/ATC.
        (function applySizeAfterHoneySwitch() {
          const paramsNow = new URLSearchParams(location.search);
          if (paramsNow.get('variant')) return; // ya hay variante en la URL: respetarla

          const sizeRoot = document.querySelector('.product-variants--size .variant-products');
          if (!sizeRoot) return;

          /** @type {HTMLElement | null} */
          let targetLi = null;

          // 1) Preservar la talla previa del usuario si existe en el nuevo producto
          if (lastSelectedSizeValue) {
            const prevBtn = sizeRoot.querySelector('.variant-product__button[data-option-value="' + CSS.escape(lastSelectedSizeValue) + '"]');
            if (prevBtn) targetLi = /** @type {HTMLElement|null} */(prevBtn.closest('.variant-product'));
          }

          // 2) Fallback: Full (2da) o 1ra
          if (!targetLi) {
            const items = sizeRoot.querySelectorAll('.variant-product');
            if (items.length >= 2) targetLi = /** @type {HTMLElement} */(items[1]);
            else if (items.length >= 1) targetLi = /** @type {HTMLElement} */(items[0]);
          }
          if (!targetLi) return;

          sizeRoot.querySelectorAll('.variant-product').forEach(li => li.classList.remove('variant-product-selected'));
          targetLi.classList.add('variant-product-selected');
          const btn = targetLi.querySelector('.variant-product__button');
          const v = btn ? (btn.getAttribute('data-option-value') || null) : null;
          if (v) lastSelectedSizeValue = v;
          const vid = btn ? (btn.getAttribute('data-variant-id') || '') : '';
          if (vid) handleSelectVariant(vid);
        })();
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        console.error('[MGO Variants] Section render error:', err);
      } finally {
        setPriceUpdatingState(false);
      }
    }

    // ---- Purchase Options (Subscription / One-time) ----
    function initPurchaseOptions() {
      const opts = document.querySelectorAll('.product-showcase__subscribe--option');
      if (!opts.length) return;
      // Si no hay activo, por defecto activar el que tenga data-type="subscription"; si no, el primero
      let anyActive = false;
      opts.forEach((el) => {
        const hasActive = el.classList.contains('is-active');
        // Strip is-active from special options to avoid them being treated as global active
        if (isSpecialOption(el)) {
          if (hasActive) el.classList.remove('is-active');
        } else if (hasActive) {
          anyActive = true;
        }
        el.removeEventListener('click', onPurchaseOptionClick, true);
        el.addEventListener('click', onPurchaseOptionClick, true);
      });
      if (!anyActive) {
        const root = document.querySelector('#subscribe-options-static');
        const isOtpAccordionScope = !!(root && root.classList.contains('ps-otp-accordion'));
        const sub = document.querySelector('.product-showcase__subscribe--option[data-type^="subscription"]');
        const onetime = document.querySelector('.product-showcase__subscribe--option[data-type="onetime"]');
        const subPlanId = sub ? (sub.getAttribute('data-selling-plan-id') || '') : '';
        /** @type {HTMLElement | null} */
        let target = null;
        if (isOtpAccordionScope) {
          target = findOptionByChoice(document, persistedPurchaseChoice);
          if (!target) target = findFallbackOptionByIntent(document, persistedPurchaseChoice);
          if (!target) {
            target = /** @type {HTMLElement | null} */(
              document.querySelector('#subscribe-options-static .product-showcase__subscribe--option.is-selected')
            );
          }
        }
        // Si no hay selling plan (no es principal o no disponible), activar onetime
        if (!target) {
          if (sub && !subPlanId && onetime) target = /** @type {HTMLElement} */ (onetime);
          else if (sub) target = /** @type {HTMLElement} */ (sub);
          else target = /** @type {HTMLElement} */ (opts[0]);
        }
        if (target) setPurchaseOptionActive(target);
      }
    }

    /**
     * @param {MouseEvent} e
     */
    function onPurchaseOptionClick(e) {
      const target = /** @type {HTMLElement} */(e.currentTarget);
      e.preventDefault();
      e.stopImmediatePropagation();
      setPurchaseOptionActive(target, true);
    }

    /**
     * @param {HTMLElement} el
     * @param {boolean} isUserAction
     */
    function setPurchaseOptionActive(el, isUserAction = false) {
      // Remove global active from all options first
      document.querySelectorAll('.product-showcase__subscribe--option').forEach((n) => n.classList.remove('is-active'));
      // Do not mark special/starter-kit as global active
      if (!isSpecialOption(el)) {
        el.classList.add('is-active');
      }
      const root = document.querySelector('#subscribe-options-static');
      if (root && root.classList.contains('ps-otp-accordion')) {
        persistPurchaseChoice(el, !!isUserAction);
      }
      // Sincronizar precios visibles en actions_single_subscribe
      try { syncActionsPriceFromActiveOption(); } catch {}
    }

    function getActivePurchaseOption() {
      // subscription-special options get is-selected but NOT is-active, so check both
      const active = document.querySelector('.product-showcase__subscribe--option.is-active')
        || document.querySelector('.product-showcase__subscribe--option.is-selected');
      const type = active ? active.getAttribute('data-type') : null;
      const sellingPlanId = active ? (active.getAttribute('data-selling-plan-id') || '') : '';
      const variantId = active ? (active.getAttribute('data-variant-id') || '') : '';
      return { type, sellingPlanId, variantId };
    }

    // ---- Add to Cart (AJAX) ----
    function bindAddToCart() {
      const btns = document.querySelectorAll(ADD_TO_CART_SELECTOR);
      if (!btns.length) return;
      btns.forEach((btn) => {
        btn.removeEventListener('click', onAddToCartClick, true);
        btn.addEventListener('click', onAddToCartClick, true);
      });
    }

    function setBundleActiveFromUrl() {
      const list = document.querySelector('.product-variants--bundle .variant-products');
      if (!list) return;
      const currentPath = window.location.pathname;
      list.querySelectorAll('.variant-product').forEach((li) => {
        li.classList.remove('variant-product-selected');
        li.classList.remove('variant-product--active');
      });
      list.querySelectorAll('.variant-product__button').forEach((btnEl) => {
        const btn = /** @type {HTMLElement} */ (btnEl);
        const url = btn.getAttribute('data-url') || '';
        const path = url ? new URL(url, window.location.origin).pathname : '';
        const li = btn.closest('.variant-product');
        if (!li) return;
        btn.classList.remove('variant-product__button--selected');
        if (path === currentPath) {
          li.classList.add('variant-product-selected');
          li.classList.add('variant-product--active');
          btn.classList.add('variant-product__button--selected');
        }
      });
      syncBundleSelectedLabel();
    }

    /**
     * @param {string} handle
     */
    function setBundleActiveByHandle(handle) {
      if (!handle) return;
      const list = document.querySelector('.product-variants--bundle .variant-products');
      if (!list) return;
      list.querySelectorAll('.variant-product').forEach((li) => {
        li.classList.remove('variant-product-selected');
        li.classList.remove('variant-product--active');
      });
      list.querySelectorAll('.variant-product__button').forEach((btnEl) => {
        const btn = /** @type {HTMLElement} */ (btnEl);
        const h = btn.getAttribute('data-product-handle') || '';
        const li = btn.closest('.variant-product');
        if (!li) return;
        btn.classList.remove('variant-product__button--selected');
        if (h === handle) {
          li.classList.add('variant-product-selected');
          li.classList.add('variant-product--active');
          btn.classList.add('variant-product__button--selected');
        }
      });
      syncBundleSelectedLabel();
    }

    /**
     * @param {MouseEvent} e
     */
    async function onAddToCartClick(e) {
      const btn = /** @type {HTMLElement} */(e.currentTarget);
      e.preventDefault();
      e.stopImmediatePropagation();

      // Determinar variante actual
      // 0) Priorizar la variante declarada en la opción de compra activa (permite Starter Kit)
      /** @type {string | null} */
      let variantId = null;
      // Tomar parámetros del href actual como fuente de verdad (product-showcase.js los mantiene al día)
      const hrefNow = btn.getAttribute('href') || '';
      let hrefIdParam = '';
      let hrefSellingPlanParam = '';
      try {
        const u = new URL(hrefNow, window.location.origin);
        hrefIdParam = u.searchParams.get('id') || '';
        hrefSellingPlanParam = u.searchParams.get('selling_plan') || '';
      } catch {}
      const { type: activeType, variantId: activeVariantId, sellingPlanId } = getActivePurchaseOption();
      const mainSelection = getCurrentMainVariantSelection();
      const selectedSizeCartVariantId = mainSelection.variantId;
      const canOptionOverrideVariant = activeType === 'subscription-special';
      const isOnetimePurchase = activeType === 'onetime';
      const isV2Context = !!(document.querySelector('#subscribe-options-static')?.getAttribute('data-actions-version') === 'v2');
      const isSubscribePurchase = !!(activeType && activeType.indexOf('subscription') === 0);

      // 1) subscription-special: siempre usar la variante SK de la opción activa
      if (canOptionOverrideVariant && activeVariantId) {
        variantId = activeVariantId;
      } else if (!isV2Context && isSubscribePurchase && activeVariantId) {
        // Legacy Actions OTP + Subscribe can carry explicit starter-kit variant on subscription option.
        variantId = activeVariantId;
      } else if (isOnetimePurchase) {
        // 2) one-time: SIEMPRE el variant real del PDP — nunca el SK ni ningún metafield
        // Fuente 1: ?variant= de la URL (actualizado por handleSelectVariant)
        variantId = new URLSearchParams(location.search).get('variant') || '';
        // Fuente 2: data-variant-id del size button (el ID real, no data-cart-variant-id que es el SK)
        if (!variantId) {
          const selBtn = /** @type {HTMLElement|null} */(
            document.querySelector('.product-variants--size .variant-product.variant-product-selected .variant-product__button')
            || document.querySelector('.product-variants--size .variant-product__button')
          );
          variantId = selBtn ? (selBtn.getAttribute('data-variant-id') || '') : '';
        }
        // NO hay fallback al href para one-time — el href puede tener el SK ID
      } else {
        // 3) subscription/default: usar variante SK-aware del size button
        if (selectedSizeCartVariantId) variantId = selectedSizeCartVariantId;
        // Fallbacks basados en href solo para subscriptions (no one-time)
        if (!variantId && hrefIdParam) variantId = hrefIdParam;
        if (!variantId) {
          const m = hrefNow.match(/id=(\d+)/);
          if (m) variantId = /** @type {string} */ (m[1]);
        }
      }
      // Fallback universal: ?variant= de la URL (cubre one-time sin size block)
      if (!variantId) variantId = new URLSearchParams(location.search).get('variant');
      // Fallback universal: size block respetando el tipo (one-time → data-variant-id real)
      if (!variantId) {
        const selBtn = /** @type {HTMLElement|null} */(
          document.querySelector('.product-variants--size .variant-product.variant-product-selected .variant-product__button')
        );
        if (selBtn) {
          variantId = isOnetimePurchase
            ? (selBtn.getAttribute('data-variant-id') || '')
            : (selBtn.getAttribute('data-cart-variant-id') || selBtn.getAttribute('data-variant-id') || '');
        }
      }
      if (!variantId) {
        console.warn('[MGO Variants] No variant ID to add.');
        return;
      }

      // Determinar selling_plan según el tipo de compra seleccionado
      let effectiveSellingPlan;
      if (isOnetimePurchase) {
        // One-time purchase: sin subscription, siempre producto real del PDP
        effectiveSellingPlan = '';
      } else if (canOptionOverrideVariant) {
        // subscription-special (SK): usar el plan de la opción activa, nunca el del href
        // El href del OTP-accordion usa principal_plan_id que no aplica al SK variant
        effectiveSellingPlan = sellingPlanId || '';
      } else if (isV2Context && mainSelection.isStarterKitOverride) {
        // El size-button apunta al SK via data-cart-variant-id: usar su plan
        effectiveSellingPlan = mainSelection.sellingPlanId || '';
      } else {
        effectiveSellingPlan = sellingPlanId || hrefSellingPlanParam || '';
      }
      const isSubscription = !!(effectiveSellingPlan);

      // Estado de cargando
      btn.classList.add('is-loading');
      try {
        await addToCartAjax({ id: Number(variantId), quantity: 1, selling_plan: isSubscription ? Number(effectiveSellingPlan) : undefined });
        // Emitir eventos para actualizar cart drawer/contador si existen
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { variantId, quantity: 1, sellingPlanId: isSubscription ? effectiveSellingPlan : null, type: activeType || '' } }));
        // Si existe un drawer, puedes escucharlo con este evento
        document.dispatchEvent(new CustomEvent('cart:open'));
        
        document.dispatchEvent(new CustomEvent('cart:update-counter'));
      } catch (err) {
        console.error('[MGO Variants] Add to cart error:', err);
        try {
          // Debug auxiliar si el backend rechaza el plan
          console.debug('[MGO Variants] Payload debug', { id: Number(variantId), quantity: 1, selling_plan: isSubscription ? Number(effectiveSellingPlan) : undefined, type: activeType });
        } catch {}
      } finally {
        btn.classList.remove('is-loading');
      }
    }

    /**
     * @param {{id: number, quantity: number, selling_plan?: number|string}} payload
     */
    async function addToCartAjax(payload) {
      const body = {
        id: payload.id,
        quantity: payload.quantity,
        ...(payload.selling_plan ? { selling_plan: payload.selling_plan } : {}),
      };
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!resp.ok) {
        const txt = await resp.text().catch(() => '');
        throw new Error('Add to cart failed: ' + resp.status + ' ' + txt);
      }
      return resp.json();
    }

    /**
     * Cambiar sólo la variante dentro del mismo producto por ID
     * @param {string} variantId
     */
    async function handleSelectVariant(variantId) {
      const sectionRoot = document.querySelector('.product-showcase');
      const sectionId = String(sectionRoot ? (sectionRoot.getAttribute('data-section-id') || '') : '');
      const basePath = window.location.pathname;
      const params = new URLSearchParams(location.search);
      params.set('variant', variantId);

      // Preserve template view parameter if present (e.g., template-starter-kit)
      const currentViewParam = new URLSearchParams(window.location.search).get('view');
      if (currentViewParam && !params.has('view')) {
        params.set('view', currentViewParam);
      }

      // Update URL preserving current product path
      const newUrl = basePath + '?' + params.toString();
      window.history.replaceState({ variantId }, '', newUrl);

      // Abort previous
      if (currentController) currentController.abort();
      currentController = new AbortController();

      // For non-product pages, we need to fetch the section using the product URL
      // Try to get product URL from the product-showcase section
      let fetchBasePath = basePath;
      const isProductPage = basePath.startsWith('/products/');
      if (!isProductPage) {
        // Try to get product URL from data attribute or ATC button
        const productUrlAttr = sectionRoot ? sectionRoot.getAttribute('data-product-url') : null;
        const atcBtn = document.querySelector('.product-showcase__add-to-cart[href*="/cart/add"]');
        if (productUrlAttr) {
          fetchBasePath = productUrlAttr;
        } else if (atcBtn) {
          // Extract product handle from variant buttons or use a fallback
          const variantBtn = document.querySelector('.product-variants__option-button[data-url]');
          if (variantBtn) {
            const variantUrl = variantBtn.getAttribute('data-url') || '';
            try {
              const u = new URL(variantUrl, window.location.origin);
              fetchBasePath = u.pathname;
            } catch {}
          }
        }
      }

      const sectionUrl = fetchBasePath + '?section_id=' + encodeURIComponent(sectionId) + '&variant=' + variantId;
      try {
        setPriceUpdatingState(true);
        const resp = await fetch(sectionUrl, { signal: currentController.signal });
        const html = await resp.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        syncProductShowcaseDataAttrs(doc, fetchBasePath);
        updateGallery(doc);
        updateTitle(doc);
        updatePrice(doc);
        updateAddToCart(doc);
        updateSizeBlock(doc);
        updateDescription(doc);
        updateBundleBlock(doc);
        updateReviewsBadge(doc);
        updateProductDescriptionTitle(doc);
        updateTabsAccordion(doc);

        // Re-mark size active
        setSizeActiveFromVariant();
        updateSelectedLabel(doc);

        // Re-bind listeners dependientes del DOM reemplazado
        initPurchaseOptions();
        bindAddToCart();
        // Re-sync ATC href: updateAddToCart puede haber escrito el plan del producto principal
        // en lugar del plan del SK variant; esto lo corrige usando la opción activa/seleccionada
        try {
          const activeOpt = /** @type {HTMLElement|null} */(
            document.querySelector('.product-showcase__subscribe--option.is-active')
              || document.querySelector('.product-showcase__subscribe--option.is-selected')
          );
          if (activeOpt) syncAddToCartHrefFromOption(activeOpt);
        } catch {}

        // Broadcast updated sticky badge text from the newly fetched section
        try {
          const nextStickyBadge = /** @type {HTMLElement|null} */(doc.querySelector('.sticky-add-to-cart__product-percentage'));
          const badgeText = (nextStickyBadge?.textContent || '').trim();
          if (badgeText) {
            document.dispatchEvent(new CustomEvent('sticky:badge-text', { detail: { text: badgeText } }));
          }
        } catch {}

        // Avisar a otros módulos
        document.dispatchEvent(new CustomEvent('pdp:product-changed', { detail: { variantId, skipApplySelection: true } }));

      } catch (err) {
        if (err && err.name === 'AbortError') return;
        console.error('[MGO Variants] Variant change error:', err);
      } finally {
        setPriceUpdatingState(false);
      }
    }

    /** @param {Document} doc */
    function updateGallery(doc) {
      const nextGallery = /** @type {HTMLElement|null} */(doc.querySelector('.product-showcase__gallery'));
      const currGallery = /** @type {HTMLElement|null} */(document.querySelector('.product-showcase__gallery'));
      if (nextGallery && currGallery) {
        // Swap the slides/thumbs markup for the new product.
        currGallery.innerHTML = nextGallery.innerHTML;

        // CRITICAL: sync the host attributes too. innerHTML does not touch them,
        // so without this the <product-showcase-gallery> element keeps the PREVIOUS
        // product's data-variant-gallery and, on the pdp:gallery-updated event below,
        // updateFromActiveVariant() would re-apply the old images over the new ones.
        ['data-variant-gallery', 'data-show-desktop-thumbs', 'data-mobile-nav'].forEach((attr) => {
          const val = nextGallery.getAttribute(attr);
          if (val !== null) currGallery.setAttribute(attr, val);
          else currGallery.removeAttribute(attr);
        });

        // Reset the element's cached "original" images so the freshly swapped
        // images become the new baseline (otherwise it could restore stale src's).
        const inst = /** @type {any} */(currGallery);
        inst._originalImages = null;
        if (typeof inst.captureOriginalImagesIfNeeded === 'function') {
          inst.captureOriginalImagesIfNeeded();
        }
      }
      // Unified gallery handles both breakpoints — no separate mobile container
      document.dispatchEvent(new CustomEvent('pdp:gallery-updated'));
    }

    /** @param {Document} doc */
    function updateTitle(doc) {
      const next = doc.querySelector('.product-showcase__title');
      const curr = document.querySelector('.product-showcase__title');
      if (next && curr) curr.textContent = next.textContent;
    }

    /** @param {Document} doc */
    function updatePrice(doc) {
      // Update ALL price elements, not just the first one
      const nextPrices = doc.querySelectorAll('.product-showcase__price');
      const currPrices = document.querySelectorAll('.product-showcase__price');
      if (nextPrices.length && currPrices.length) {
        // Match by index position and only patch text/class state to avoid DOM node recreation flicker.
        nextPrices.forEach((nextPrice, index) => {
          const currPrice = /** @type {HTMLElement|null} */(currPrices[index] || null);
          const nextPriceEl = /** @type {HTMLElement|null} */(nextPrice || null);
          if (!currPrice || !nextPriceEl) return;

          const nextCurrent = /** @type {HTMLElement|null} */(nextPriceEl.querySelector('.product-showcase__current-price'));
          const nextCompare = /** @type {HTMLElement|null} */(nextPriceEl.querySelector('.product-showcase__compare-price'));
          const currCurrent = /** @type {HTMLElement|null} */(currPrice.querySelector('.product-showcase__current-price'));
          const currCompare = /** @type {HTMLElement|null} */(currPrice.querySelector('.product-showcase__compare-price'));

          if (currCurrent && nextCurrent) {
            currCurrent.textContent = nextCurrent.textContent;
          }

          if (currCompare && nextCompare) {
            currCompare.textContent = nextCompare.textContent;
            currCompare.classList.toggle('is-hidden', nextCompare.classList.contains('is-hidden'));
            currCompare.setAttribute('aria-hidden', nextCompare.getAttribute('aria-hidden') || 'false');

            if (nextCompare.dataset.originalCompare) {
              currCompare.dataset.originalCompare = nextCompare.dataset.originalCompare;
            }
            if (nextCompare.dataset.lastCompare) {
              currCompare.dataset.lastCompare = nextCompare.dataset.lastCompare;
            }
            if (nextCompare.dataset.source) {
              currCompare.dataset.source = nextCompare.dataset.source;
            }
          }

          currPrice.classList.toggle('has-compare', nextPriceEl.classList.contains('has-compare'));
        });
      }
      // Also update the One-Time price card if present
      const nextOneTime = doc.querySelector('#pso-onetime-price');
      const currOneTime = document.querySelector('#pso-onetime-price');
      if (nextOneTime && currOneTime) {
        currOneTime.innerHTML = nextOneTime.innerHTML || (nextOneTime.textContent || '');
      }
      // And update Subscribe & Save (principal plan) price and save badge if present
      const nextSubsPrice = doc.querySelector('#pso-subscribe-price');
      const currSubsPrice = document.querySelector('#pso-subscribe-price');
      if (nextSubsPrice && currSubsPrice) {
        currSubsPrice.innerHTML = nextSubsPrice.innerHTML || (nextSubsPrice.textContent || '');
      }
      const nextSubsSave = doc.querySelector('#pso-subscribe-save');
      const currSubsSave = document.querySelector('#pso-subscribe-save');
      if (nextSubsSave && currSubsSave) {
        currSubsSave.innerHTML = nextSubsSave.innerHTML || (nextSubsSave.textContent || '');
      }
      // Ensure subscribe options container (with data attributes) is synced as well
      const nextSubscribeOpts = doc.querySelector('#subscribe-options-static');
      const currSubscribeOpts = document.querySelector('#subscribe-options-static');
      if (nextSubscribeOpts && currSubscribeOpts) {
        /** @type {Record<string, string>} */
        const savedOptionPrices = {};
        currSubscribeOpts.querySelectorAll('.product-showcase__subscribe--option').forEach((optEl) => {
          const opt = /** @type {HTMLElement} */(optEl);
          const type = opt.getAttribute('data-type') || '';
          const priceText = opt.getAttribute('data-price-text')
            || (opt.querySelector('.product-showcase__subscribe--options--price')?.textContent || '').trim();
          if (type && priceText) savedOptionPrices[type] = priceText;
        });

        const isOtpAccordionScope = currSubscribeOpts.classList.contains('ps-otp-accordion')
          || /** @type {HTMLElement} */(nextSubscribeOpts).classList.contains('ps-otp-accordion');

        /** @type {{type: string, sellingPlanId: string, variantId: string} | null} */
        let previousState = null;
        if (isOtpAccordionScope) {
          if (hasUserPurchaseChoice) {
            previousState = persistedPurchaseChoice;
          }
          if (!previousState && !hasUserPurchaseChoice) {
            const prevActive = /** @type {HTMLElement|null} */(
              currSubscribeOpts.querySelector('.product-showcase__subscribe--option.is-selected, .product-showcase__subscribe--option.is-active')
            );
            if (prevActive) {
              previousState = {
                type: prevActive.getAttribute('data-type') || '',
                sellingPlanId: prevActive.getAttribute('data-selling-plan-id') || '',
                variantId: prevActive.getAttribute('data-variant-id') || '',
              };
            }
          }
        }

        // Pre-apply user choice on incoming HTML so the swap renders the final state directly.
        if (isOtpAccordionScope) {
          const preferredIncoming = resolvePreferredPurchaseOption(
            /** @type {ParentNode} */(nextSubscribeOpts),
            previousState
          );
          applyPurchaseSelectionState(/** @type {ParentNode} */(nextSubscribeOpts), preferredIncoming, false);
        }

        currSubscribeOpts.innerHTML = /** @type {HTMLElement} */(nextSubscribeOpts).innerHTML;

        currSubscribeOpts.querySelectorAll('.product-showcase__subscribe--option').forEach((optEl) => {
          const opt = /** @type {HTMLElement} */(optEl);
          const type = opt.getAttribute('data-type') || '';
          if (!type) return;

          const incomingPrice = (opt.getAttribute('data-price-text') || '').trim();
          if (incomingPrice) return;

          const savedPrice = (savedOptionPrices[type] || '').trim();
          if (!savedPrice) return;

          opt.setAttribute('data-price-text', savedPrice);
          const priceNode = /** @type {HTMLElement|null} */(opt.querySelector('.product-showcase__subscribe--options--price'));
          if (priceNode && !(priceNode.textContent || '').trim()) {
            priceNode.textContent = savedPrice;
          }
        });

        // Re-add data-onetime-only attribute to one-time purchase button after innerHTML replacement
        // Note: in the ps-otp-accordion layout the ATC is outside #subscribe-options-static
        const onetimeBtn = currSubscribeOpts.querySelector('#ps-add-to-cart-onetime') || document.querySelector('#ps-add-to-cart-onetime');
        if (onetimeBtn) {
          onetimeBtn.setAttribute('data-onetime-only', 'true');
        }

        /** @type {HTMLElement | null} */
        let selectedOpt = null;
        if (isOtpAccordionScope && previousState) {
          selectedOpt = findOptionByChoice(currSubscribeOpts, previousState);
          if (!selectedOpt) {
            selectedOpt = findFallbackOptionByIntent(currSubscribeOpts, previousState);
          }
          if (selectedOpt) {
            applyPurchaseSelectionState(currSubscribeOpts, selectedOpt, false);
            persistPurchaseChoice(selectedOpt, false);
          }
        }
        if (!selectedOpt && !hasUserPurchaseChoice) {
          selectedOpt = /** @type {HTMLElement|null} */(
            currSubscribeOpts.querySelector('.product-showcase__subscribe--option.is-selected')
              || currSubscribeOpts.querySelector('.product-showcase__subscribe--option')
          );
        }

        if (!selectedOpt) {
          selectedOpt = /** @type {HTMLElement|null} */(
            currSubscribeOpts.querySelector('.product-showcase__subscribe--option[data-type^="subscription"]')
              || currSubscribeOpts.querySelector('.product-showcase__subscribe--option[data-type="onetime"]')
              || currSubscribeOpts.querySelector('.product-showcase__subscribe--option')
          );
        }

        if (selectedOpt) {
          applyPurchaseSelectionState(currSubscribeOpts, selectedOpt, true);
          try { syncActionsPriceFromActiveOption(); } catch {}

          const selectedType = selectedOpt.getAttribute('data-type') || '';
          document.dispatchEvent(new CustomEvent('pdp:purchase-choice-changed', {
            detail: {
              type: selectedType,
              sellingPlanId: selectedOpt.getAttribute('data-selling-plan-id') || '',
              variantId: selectedOpt.getAttribute('data-variant-id') || '',
              origin: hasUserPurchaseChoice ? 'user' : 'default',
            }
          }));
        }
      }

    }

    /** @param {Document} doc */
    function updateAddToCart(doc) {
      const nexts = doc.querySelectorAll('.product-showcase__add-to-cart');
      const currs = document.querySelectorAll('.product-showcase__add-to-cart');
      if (!nexts.length || !currs.length) return;
      
      // Find a subscription button (NOT one-time-only) to use as reference for subscription buttons
      let subscriptionHref = '';
      for (const btn of nexts) {
        if (!btn.hasAttribute('data-onetime-only')) {
          subscriptionHref = btn.getAttribute('href') || '';
          if (subscriptionHref) break;
        }
      }
      
      // Find the one-time button in the new document to get the ACTUAL product variant ID
      let onetimeVariantId = '';
      const nextOnetimeBtn = doc.querySelector('.product-showcase__add-to-cart[data-onetime-only="true"]');
      if (nextOnetimeBtn) {
        const onetimeHref = nextOnetimeBtn.getAttribute('href') || '';
        if (onetimeHref) {
          const onetimeUrl = new URL(onetimeHref, window.location.origin);
          onetimeVariantId = onetimeUrl.searchParams.get('id') || '';
        }
      }
      
      // Update all buttons
      currs.forEach((el) => {
        if (!el.hasAttribute('data-onetime-only')) {
          // Update subscription buttons with subscription href
          if (subscriptionHref) {
            el.setAttribute('href', subscriptionHref);
          }
        } else if (onetimeVariantId) {
          // For one-time button, use the variant ID from the one-time button in new document
          // This ensures we ALWAYS use the current product's variant, never the starter kit
          const onetimeUrl = new URL(el.getAttribute('href') || '/cart/add', window.location.origin);
          onetimeUrl.searchParams.set('id', onetimeVariantId);
          onetimeUrl.searchParams.delete('selling_plan'); // Ensure no subscription
          const onetimeHref = onetimeUrl.pathname + '?' + onetimeUrl.searchParams.toString();
          el.setAttribute('href', onetimeHref);
        }
      });
    }

    function syncSizeSelectedLabel() {
      const blocks = document.querySelectorAll('.product-variants--size');
      if (!blocks.length) return;

      const currentVariant = new URLSearchParams(window.location.search).get('variant') || '';

      blocks.forEach((blockEl) => {
        const block = /** @type {HTMLElement} */(blockEl);
        const selectedSpan = /** @type {HTMLElement|null} */(block.querySelector('.product-variants__selected'));
        if (!selectedSpan) return;

        /** @type {HTMLElement|null} */
        let btn = null;
        if (currentVariant) {
          btn = /** @type {HTMLElement|null} */(block.querySelector('.variant-product__button[data-variant-id="' + CSS.escape(currentVariant) + '"]'));
        }
        if (!btn) {
          btn = /** @type {HTMLElement|null} */(
            block.querySelector('.variant-product.variant-product-selected .variant-product__button')
              || block.querySelector('.variant-product.variant-product--active .variant-product__button')
              || block.querySelector('.variant-product__button')
          );
        }
        if (!btn) return;

        const card = /** @type {HTMLElement|null} */(btn.closest('.variant-product'));
        const title = (card?.querySelector('.variant-product__title')?.textContent || '').trim();
        const fallbackValue = (btn.getAttribute('data-option-value') || '').trim();
        const nextText = (title || fallbackValue).trim();
        if (nextText) selectedSpan.textContent = nextText;
      });
    }

    function syncBundleSelectedLabel() {
      const bundles = document.querySelectorAll('.product-variants--bundle');
      if (!bundles.length) return;

      bundles.forEach((bundleEl) => {
        const bundle = /** @type {HTMLElement} */(bundleEl);
        const selectedSpan = /** @type {HTMLElement|null} */(bundle.querySelector('.product-variants__selected'));
        if (!selectedSpan) return;

        const btn = /** @type {HTMLElement|null} */(
          bundle.querySelector('.variant-product.variant-product--active .variant-product__button')
            || bundle.querySelector('.variant-product.variant-product-selected .variant-product__button')
            || bundle.querySelector('.variant-product__button.variant-product__button--selected')
            || bundle.querySelector('.variant-product__button')
        );
        if (!btn) return;

        const card = /** @type {HTMLElement|null} */(btn.closest('.variant-product'));
        const title = (card?.querySelector('.variant-product__title')?.textContent || '').trim();
        if (title) selectedSpan.textContent = title;
      });
    }

    /** @param {Document} doc */
    function syncHoneySelectedLabel(doc) {
      const nextSpan = doc.querySelector('.product-variants--honey .product-variants__selected');
      const currSpan = document.querySelector('.product-variants--honey .product-variants__selected');
      if (!nextSpan || !currSpan) return;
      const text = (nextSpan.textContent || '').trim();
      if (text) currSpan.textContent = text;
    }

    /** @param {Document} doc */
    function updateSelectedLabel(doc) {
      syncHoneySelectedLabel(doc);
      syncSizeSelectedLabel();
      syncBundleSelectedLabel();
    }

    /** @param {Document} doc */
    function updateDescription(doc) {
      // Preferred: dedicated ID slot if present
      const nextById = doc.querySelector('#ps-slot-description');
      const currById = document.querySelector('#ps-slot-description');
      if (nextById && currById) {
        currById.innerHTML = /** @type {HTMLElement} */(nextById).innerHTML;
        return;
      }
      // Fallback: generic block-subtitle node
      const next = doc.querySelector('.product-showcase__info-block.block-subtitle');
      const curr = document.querySelector('.product-showcase__info-block.block-subtitle');
      if (next && curr) {
        curr.innerHTML = /** @type {HTMLElement} */(next).innerHTML;
      }
    }

    /** @param {Document} doc */
    function updateVariantsOptions(doc) {
      // Mantener el orden de las tarjetas de honey variants SIEMPRE.
      // No reemplazamos el HTML para evitar que cambie el orden al cambiar de producto.
      // El estado activo se gestiona con setVariantActiveFromUrl() y onVariantClick().
      // Si en el futuro se necesitara sincronizar etiquetas/URLs internas, hacerlo
      // de forma puntual sin reordenar nodos.
      const curr = document.querySelector('.product-variants__options');
      if (!curr) return;
      // Opcional: refrescar textos/URLs específicas sin alterar el orden.
    }

    // Forzar inyección del bloque de tamaño si no está presente en el DOM inicial
    async function ensureSizeBlockOnLoad() {
      const existing = document.querySelector('.product-variants--size');
      // Si ya existe, nada que hacer
      if (existing) return;
      const sectionRoot = document.querySelector('.product-showcase');
      const sectionId = String(sectionRoot ? (sectionRoot.getAttribute('data-section-id') || '') : '');
      const basePath = window.location.pathname;
      const params = new URLSearchParams(location.search);
      const sectionUrl = basePath + '?section_id=' + encodeURIComponent(sectionId) + (params.size ? ('&' + params.toString()) : '');
      try {
        const resp = await fetch(sectionUrl);
        if (!resp.ok) return;
        const html = await resp.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        updateSizeBlock(doc);
        setSizeActiveFromVariant();
      } catch (e) {
        console.warn('[MGO Variants] ensureSizeBlockOnLoad failed:', e);
      }
    }

    /** @param {Document} doc */
    function updateSizeBlock(doc) {
      const next = doc.querySelector('.product-variants--size');
      const curr = document.querySelector('.product-variants--size');
      if (!next) {
        // Target product has no size selector; remove existing if present
        if (curr && curr.parentElement) {
          curr.parentElement.removeChild(curr);
        }
        return;
      }
      if (curr) {
        curr.innerHTML = next.innerHTML;
        const newSizeContainer = curr.querySelector('.variant-products');
        if (newSizeContainer) newSizeContainer.addEventListener('click', onSizeClick, true);
        return;
      }
      // If current page didn't have the size block, insert it in a stable position
      const info = document.querySelector('.product-showcase__info');
      if (info) {
        const clone = /** @type {HTMLElement} */ (next.cloneNode(true));
        // Prefer to insert right after the honey variants block to keep expected order
        const honeyBlock = info.querySelector('.product-variants.product-variants--honey');
        if (honeyBlock && honeyBlock.parentElement) {
          honeyBlock.parentElement.insertBefore(clone, honeyBlock.nextSibling);
        } else {
          // Fallback: insert at the top of the info column
          info.insertBefore(clone, info.firstChild);
        }
        const newSizeContainer = clone.querySelector('.variant-products');
        if (newSizeContainer) newSizeContainer.addEventListener('click', onSizeClick, true);
      }
    }

    function setVariantActiveFromUrl() {
      const list = document.querySelector('.product-variants__options');
      if (!list) return;
      const currentPath = window.location.pathname;
      list.querySelectorAll('.product-variants__option-button').forEach((btnEl) => {
        const btn = /** @type {HTMLElement} */ (btnEl);
        const url = btn.getAttribute('data-url') || '';
        const path = url ? new URL(url, window.location.origin).pathname : '';
        const li = btn.closest('.product-variants__option');
        if (!li) return;
        if (path === currentPath) li.classList.add('product-variants__option--active');
        else li.classList.remove('product-variants__option--active');
      });
    }

 function setSizeActiveFromVariant() {
  const list = document.querySelector('.product-variants--size .variant-products');
  if (!list) return;
  const params = new URLSearchParams(location.search);
  const currentVariant = params.get('variant');

  list.querySelectorAll('.variant-product').forEach((li) => li.classList.remove('variant-product-selected'));

  list.querySelectorAll('.variant-product__button').forEach((btnEl) => {
    const btn = /** @type {HTMLElement} */ (btnEl);
    const vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    const li = btn.closest('.variant-product');
    if (!li) return;
    if (!currentVariant) {
      // no-op aquí; manejamos el caso sin URL abajo
      return;
    }
    if (vid === currentVariant) li.classList.add('variant-product-selected');
  });

  if (!currentVariant) {
    // Forzar Full (índice 1) si existe; si no, la primera
    const items = list.querySelectorAll('.variant-product');
    /** @type {HTMLElement | null} */
    let defaultItem = null;
    if (items.length >= 2) defaultItem = /** @type {HTMLElement} */(items[0]);
    else if (items.length >= 1) defaultItem = /** @type {HTMLElement} */(items[0]);

    if (defaultItem) {
      list.querySelectorAll('.variant-product').forEach(li => li.classList.remove('variant-product-selected'));
      defaultItem.classList.add('variant-product-selected');
      const btn = defaultItem.querySelector('.variant-product__button');
      const v = btn ? (btn.getAttribute('data-option-value') || null) : null;
      if (v) lastSelectedSizeValue = v;
    }
  }
}

    // Nuevo: click en cards del bloque "variants_bundle"
    document.addEventListener('click', async (evt) => {
  const btn = evt.target.closest('.product-variants--bundle .variant-product__button');
  if (!btn) return;

  evt.preventDefault();

  // Estilos de selección: aplicar clases en LI y en el botón para mantener el estado visual
  const bundleRoot = document.querySelector('.product-variants--bundle .variant-products');
  if (bundleRoot) {
    bundleRoot.querySelectorAll('.variant-product').forEach(el => {
      el.classList.remove('variant-product-selected');
      el.classList.remove('variant-product--active');
    });
    bundleRoot.querySelectorAll('.variant-product__button').forEach(el => el.classList.remove('variant-product__button--selected'));
  }
  const li = btn.closest('.variant-product');
  if (li) {
    li.classList.add('variant-product-selected');
    li.classList.add('variant-product--active');
  }
  btn.classList.add('variant-product__button--selected');

  // Actualización dinámica del PDP (igual que los otros switchers)
  const targetUrl = btn.dataset.url;
  const sectionEl = document.querySelector('.product-showcase[data-section-id]');
  if (!targetUrl || !sectionEl) return;

  // Actualiza la URL del navegador para reflejar el producto actual (sin recargar)
  try {
    const resolved = new URL(targetUrl, window.location.origin);
    if (window.location.pathname !== resolved.pathname) {
      window.history.replaceState({ productUrl: resolved.href }, '', resolved.href);
    }
  } catch {}

  const sectionId = sectionEl.getAttribute('data-section-id');
  const fetchUrl = `${targetUrl}?section_id=${encodeURIComponent(sectionId)}`;

  try {
    const res = await fetch(fetchUrl, { credentials: 'same-origin' });
    const html = await res.text();

    // Reutilizamos la misma rutina que ya usas para honey/size:
    // Si tienes una función existente para "inyectar" la sección, úsala aquí.
    // Por ejemplo, si ya tienes algo como swapSectionParts(html) o updatePdpFromSection(html):
    if (typeof window.updatePdpFromSection === 'function') {
      window.updatePdpFromSection(html);
    } else {
      // Fallback genérico: reemplazo de fragmentos clave (mismo patrón que ya tienes en el manejador de honey/size)
      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      const newRoot = tmp.querySelector('.product-showcase');
      const oldRoot = document.querySelector('.product-showcase');
      if (newRoot && oldRoot) {
        const incomingSubscribeRoot = /** @type {ParentNode|null} */(newRoot.querySelector('#subscribe-options-static'));
        if (incomingSubscribeRoot) {
          const incomingPreferred = resolvePreferredPurchaseOption(incomingSubscribeRoot, persistedPurchaseChoice);
          applyPurchaseSelectionState(incomingSubscribeRoot, incomingPreferred, false);
        }

        // Actualiza zonas críticas que ya manipulas en otros handlers:
        const mapSelectors = [
          '.product-showcase__gallery',
          '#ps-slot-title',
          '#ps-slot-price',
          '#subscribe-options-static',
          '.product-variants--size',     // por si cambia el bloque de size
          '.product-variants--bundle',   // actualizar bundle selector con nuevo producto activo
          '.block-table'                 // beneficios/metafield
        ];

        mapSelectors.forEach(sel => {
          const oldNode = oldRoot.querySelector(sel);
          const newNode = newRoot.querySelector(sel);
          if (oldNode && newNode) oldNode.replaceWith(newNode);
        });
      }
    }

    // Re-bind de opciones de compra y ATC tras el swap, para que el bundle single action funcione
    initPurchaseOptions();
    bindAddToCart();

    // Re-marcar selección del bundle conforme a la URL actual
    setBundleActiveFromUrl();
    // Y asegurar marcado por handle de la card clicada
    const clickedHandle = btn.getAttribute('data-product-handle') || btn.dataset.productHandle || '';
    if (clickedHandle) setBundleActiveByHandle(clickedHandle);

    // Si la card clicada apunta a una variante específica distinta a la actual, aplicar el cambio de variante
    const paramsAfterSwap = new URLSearchParams(location.search);
    const currentVariantParam = paramsAfterSwap.get('variant');
    const clickedVariantId = btn.dataset.variantId;
    if (clickedVariantId && clickedVariantId !== currentVariantParam) {
      try {
        await handleSelectVariant(String(clickedVariantId));
        try { syncActionsPriceFromActiveOption(); } catch {}
        // Reaplicar marcado por handle tras cambio de variante
        const clickedHandle2 = btn.getAttribute('data-product-handle') || btn.dataset.productHandle || '';
        if (clickedHandle2) setBundleActiveByHandle(clickedHandle2);
      } catch (e) {
        console.warn('[MGO Variants] Bundle variant apply failed:', e);
      }
    }

    // Reaplicar la opción de compra previa del usuario (si existe), sin forzar subscription.
    const purchaseScope = /** @type {ParentNode} */(document.querySelector('#subscribe-options-static') || document);
    let preferredOption = findOptionByChoice(purchaseScope, persistedPurchaseChoice);
    if (!preferredOption) preferredOption = findFallbackOptionByIntent(purchaseScope, persistedPurchaseChoice);
    if (!preferredOption) {
      preferredOption = /** @type {HTMLElement|null} */(
        document.querySelector('#subscribe-options-static .product-showcase__subscribe--option.is-selected')
          || document.querySelector('#subscribe-options-static .product-showcase__subscribe--option.is-active')
          || document.querySelector('#subscribe-options-static .product-showcase__subscribe--option')
      );
    }
    if (preferredOption) {
      const optionsRoot = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
      if (optionsRoot) applyPurchaseSelectionState(optionsRoot, preferredOption, false);
      const scopeForAccordion = /** @type {ParentNode} */(document.querySelector('#subscribe-options-static') || document);
      applyPurchaseSelectionState(scopeForAccordion, preferredOption, true);
      persistPurchaseChoice(preferredOption, false);
    }

    // Mantener el precio visible en header de acciones
    (function syncVisiblePrice() {
      const priceWrap = document.querySelector('#ps-slot-price, .product-showcase__price');
      if (!priceWrap) return;
      // Si al cambiar la opción se vació, volver a tomarlo del DOM actual (ya reemplazado)
      const current = priceWrap.querySelector('.product-showcase__current-price');
      if (!current || !current.textContent || !current.textContent.trim()) {
        const source = document.querySelector('#ps-slot-price .product-showcase__current-price, .product-showcase__price .product-showcase__current-price');
        if (source && current) current.textContent = source.textContent || '';
      }
    })();

    // Sincronizar Sticky ATC con la opción seleccionada (como hace product-showcase.js)
    (function broadcastOptionSelected() {
      const priceWrap = document.querySelector('#ps-slot-price, .product-showcase__price');
      const compareNode = priceWrap ? priceWrap.querySelector('.product-showcase__compare-price') : null;
      const currentNode = priceWrap ? priceWrap.querySelector('.product-showcase__current-price') : null;
      const compareText = compareNode ? (compareNode.textContent || '').trim() : '';
      const priceText = currentNode ? (currentNode.textContent || '').trim() : '';
      const activeOrSelected = /** @type {HTMLElement|null} */(
        document.querySelector('.product-showcase__subscribe--option.is-active')
          || document.querySelector('.product-showcase__subscribe--option.is-selected')
      );
      const planId = activeOrSelected ? (activeOrSelected.getAttribute('data-selling-plan-id') || '') : '';
      const type = activeOrSelected ? (activeOrSelected.getAttribute('data-type') || (planId ? 'subscription' : 'onetime')) : (planId ? 'subscription' : 'onetime');
      document.dispatchEvent(new CustomEvent('pdp:option-selected', {
        detail: {
          type,
          planId,
          variantId: clickedVariantId || '',
          priceText,
          compareText
        }
      }));
    })();

    // Forzar visibilidad sticky si lo usas
    if (typeof window.ensureStickyVisible === 'function') window.ensureStickyVisible();

    // Emitir evento para sincronizar otros componentes sin reimponer defaults.
    document.dispatchEvent(new CustomEvent('pdp:product-changed', { detail: { skipApplySelection: true } }));

  } catch (err) {
    // Puedes añadir logging si lo necesitas
    console.error('Bundle switch failed', err);
  }
    });
  });
})();